import type { Key } from 'react';
export enum OrderShortType {
  Ascend = 'asc',
  Descend = 'desc',
}

export const enum OrderType {
  Ascend = 'ascend',
  Descend = 'descend',
}

export interface IListBaseParams {
  sortName: Key | undefined;
  sortOrder: OrderShortType | undefined;
  page: number;
  pageSize: number;
  search: string;
  type?: string;
  app?: string;
  directoryId?: string;
  groupId?: string;
}

export interface IPageInfo {
  page: number;
  page_size: number;
  total_page: number;
  total: number;
}

export interface IListResponse<T> {
  rows: T[];
  count: number;
}

export interface IFetchConfig {
  url: string;
  method: 'GET' | 'POST' | 'DELETE' | 'PUT';
}

export interface IDataModelFetchConfig {
  get: IFetchConfig;
  edit: IFetchConfig;
  create: IFetchConfig;
}

export interface IManagerModelFetchConfig {
  list: IFetchConfig;
  delete: IFetchConfig;
}
